import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withFragmentIdProp,
    withMetadata,
} from '@pf/shared-utility';
import {
    PutAwayCreate,
    PutAwayDto,
    PutAwayRead,
    PutAwaySearchParams,
} from '../../entities/put-away.dto';
import { UserFragmentSymbol } from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.PutAway);

withDefaultEntityMetadata<PutAwayDto>(symbols.dto, {
    putAwayByUser: UserFragmentSymbol,
    putAwayListId: String,
    inventoryBundle: Object,
    container: Object,
    putAwayToSlot: Object,
});

withDefaultEntityMetadata<PutAwayRead>(symbols.entity, {
    putAwayByUser: UserFragmentSymbol,
    inventoryBundle: Object,
    container: Object,
    putAwayToSlot: Object,
});

withMetadata<PutAwayCreate>(symbols.createBody, {
    putAwayByUserId: String,
    inventoryBundleId: String,
    containerId: String,
    putAwayToSlotId: String,
});

withDefaultSearchParamsMetadata<PutAwaySearchParams>(symbols.searchParams, {});

export const PutAwayMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PutAwayRead, PutAwayDto>(mapper, symbols.entity, symbols.dto);
        createMap<PutAwayDto, PutAwayRead>(mapper, symbols.dto, symbols.entity);
        createMap<PutAwayDto, PutAwayCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            withFragmentIdProp('putAwayByUser'),
            withFragmentIdProp('inventoryBundle'),
            withFragmentIdProp('container'),
            withFragmentIdProp('putAwayToSlot')
        );
        createMap<IQueryParams<PutAwayDto>, PutAwaySearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            ...withDefaultSearchParamsMappingConfiguration<PutAwaySearchParams>()
        );
    },
};
